export const trackHeapEvent = (eventName: string, properties?: Record<string, any>) => {
    try {
        if (typeof window !== 'undefined' && (window as any).heap) {
            (window as any).heap.track(eventName, properties);
        }
    } catch (e) {
        // swallow analytics errors
    }
};


